import { setLogin } from "reduxStore/state";
import { fetchUsers } from "./userActions";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const loginUser = (values) => async (dispatch) => {
  try {
    const loggedInResponse = await fetch(`${BASE_URL}/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(values),
    });
    const loggedIn = await loggedInResponse.json();

    if (loggedIn.firstTimeLogin) {
      // If firstTimeLogin is true, redirect to the password reset page
      return { firstTimeLogin: true, message: loggedIn.message };
    }

    if (!loggedIn.message) {
      dispatch(
        setLogin({
          user: loggedIn.user,
          token: loggedIn.token,
          roles: loggedIn.roles,
        })
      );
    }

    return loggedIn;
  } catch (error) {
    // Handle any error that might occur during the login process
    console.error("Error while logging in:", error);
    return null;
  }
};

export const registerUser = (values) => async (dispatch, getState) => {
  try {
    const token = getState().token;

    const response = await fetch(`${BASE_URL}/auth/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(values),
    });

    if (!response.ok) {
      throw new Error("Failed to register user");
    }

    const user = await response.json();

    dispatch(fetchUsers()); // Fetch all users to update the list

    return user;
  } catch (error) {
    console.error("Error while registering user:", error);
    return null;
  }
};

export const sendPasswordResetEmail = (email) => async (dispatch) => {
  try {
    const response = await fetch(`${BASE_URL}/auth/initiate-password-reset`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email }),
    });

    if (!response.ok) {
      throw new Error("Failed to send password reset email");
    }

    return true;
  } catch (error) {
    console.error("Error while sending password reset email:", error);
    return false;
  }
};

export const resetPassword = (token, password) => async (dispatch) => {
  try {
    const response = await fetch(`${BASE_URL}/auth/reset-password`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token, password }),
    });

    const result = await response.json(); // Parse the JSON response

    if (!response.ok) {
      // Handle error response and throw it so it can be caught
      throw new Error(result.message || "Failed to reset password");
    }

    return result; // On success, return the result
  } catch (error) {
    console.error("Error while resetting password:", error);
    return { success: false, message: error.message }; // Ensure that error message is propagated
  }
};
